import { render, staticRenderFns } from "./StockWarnEmail.vue?vue&type=template&id=5010b6b7&scoped=true"
import script from "./StockWarnEmail.vue?vue&type=script&lang=js"
export * from "./StockWarnEmail.vue?vue&type=script&lang=js"
import style0 from "./StockWarnEmail.vue?vue&type=style&index=0&id=5010b6b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5010b6b7",
  null
  
)

export default component.exports